import Schedule from '../../services/schedule'
import * as types from '../mutationTypes'

let state = {
  error: null,
  scheduleByTask: [],
  scheduleDay: null
}

const getters = {
  scheduleByTask(state) {
    return state.scheduleByTask
  },
  error(state) {
    return state.error
  },
  scheduleDay(state) {
    return state.scheduleDay
  },
  getDefaultTimes() {
    return {
      start: '07:00',
      end: '15:30',
      none: '00:00'
    }
  }
}

const actions = {
  async loadSchedule({ commit, dispatch  }, workOrderTaskId) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Schedule.getByTask(workOrderTaskId)
      if (res) {
        commit(types.REQUEST_GET_SCHEDULE_BY_TASK_SUCCESS, res.data)       
      }
    } catch (err) {
      commit(types.REQUEST_GET_SCHEDULE_BY_TASK_ERROR, 'Error gettting schedule for task')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async createScheduledDay({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Schedule.create(data)
      if (res) {
        commit(types.REQUEST_CREATE_SCHEDULE_SUCCESS, res.data)
        dispatch('loadSchedule', res.data.workOrderTaskId)
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_SCHEDULE_ERROR, 'Error adding to the schedule, there may be a schedule conflict with the assigned crew')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateScheduledDay({ commit, dispatch }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Schedule.update(data)
      if (res) {
        commit(types.REQUEST_UPDATE_SCHEDULE_SUCCESS, res.data)
        dispatch('loadSchedule', res.data.workOrderTaskId)
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_SCHEDULE_ERROR, 'Error updating the schedule, there may be a schedule conflict with the assigned crew')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async deleteScheduledDay({ commit, dispatch, state  }, data) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await Schedule.delete(data)
      if (res) {
        commit(types.REQUEST_DELETE_SCHEDULE_SUCCESS, res.data)
        dispatch('loadSchedule', res.data.workOrderTaskId)
      }
    } catch (err) {
      commit(types.REQUEST_DELETE_SCHEDULE_ERROR, 'Error deleting the schedule')
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearSchedule({ state }) {
    state.scheduleByTask = []
  }
}

const mutations = {
  [types.REQUEST_GET_SCHEDULE_BY_TASK_SUCCESS](state, data) {
    state.scheduleByTask = data
    state.error = null
  },
  [types.REQUEST_GET_SCHEDULE_BY_TASK_ERROR](state, message) {
    state.error = message
    state.scheduleByTask = []
  },
  [types.REQUEST_CREATE_SCHEDULE_SUCCESS](state, data) {
    state.error = null
    state.scheduleDay = data
  },
  [types.REQUEST_CREATE_SCHEDULE_ERROR](state, message) {
    state.error = message
    state.scheduleDay = null
  },
  [types.REQUEST_UPDATE_SCHEDULE_SUCCESS](state, data) {
    state.error = null
    state.scheduleDay = data
  },
  [types.REQUEST_UPDATE_SCHEDULE_ERROR](state, message) {
    state.error = message
    state.scheduleDay = null
  },
  [types.REQUEST_DELETE_SCHEDULE_SUCCESS](state, data) {
    state.error = null
    state.scheduleDay = data
  },
  [types.REQUEST_DELETE_SCHEDULE_ERROR](state, message) {
    state.error = message
    state.scheduleDay = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
